import { BettingType } from "@gp/models";
import BaseEventViewStore from "./BaseEventViewStore";

export type TBettingTypeGroup = {
	name: string;
	abrv: string;
	id: string;
	sortOrder: 1;
	bettingTypes: BettingType[];
};

export default class EventViewStore extends BaseEventViewStore {}
